// extracted by mini-css-extract-plugin
var _1 = "tjs-timeline-controls__controls";
var _2 = "tjs-timeline-controls__is-active";
var _3 = "tjs-timeline-controls__is-active";
var _4 = "tjs-timeline-controls__timeline__control tjs-_buttons__btn";
var _5 = "tjs-timeline-controls__timeline__control tjs-_buttons__btn";
export { _1 as "controls", _2 as "is-active", _3 as "isActive", _4 as "timelineControl", _5 as "timeline__control" }
export default { "controls": _1, "is-active": _2, "isActive": _3, "timelineControl": _4, "timeline__control": _5 }
